import { sourcePromoCodeHandler } from './sourcePromoCodeHandler';

export const updatedHeroBanner = data => ({
  ...data,
  slides: data?.slides?.map(slide => {
    const updatedButtons = slide?.buttons?.map(button => ({
      ...button,
      url: button?.url ? sourcePromoCodeHandler(button?.url) : button?.url
    }));

    return {
      ...slide,
      buttons: updatedButtons
    };
  })
});

export const conditionalUpdatedHeroBanner = data => ({
  ...data,
  slides: data?.slides?.map(slide => {
    const updatedButtons = slide?.buttons?.map(button => {
      let shouldApplyPromoCode = false;
      try {
        const urlObj = new URL(button?.url);
        if (
          urlObj.hostname === 'cards.latitudefinancial.com' ||
          urlObj.hostname === 'cardapp.latitudefinancial.com'
        ) {
          shouldApplyPromoCode = true;
        }
      } catch (e) {
        shouldApplyPromoCode = false;
      }

      return {
        ...button,
        url: shouldApplyPromoCode
          ? sourcePromoCodeHandler(button?.url)
          : button?.url
      };
    });

    return {
      ...slide,
      buttons: updatedButtons
    };
  })
});

export const updatedPromoBanner = data => ({
  ...data,
  promoCards: data?.promoCards?.map(card => {
    const updatedPrimaryButton = {
      ...card?.primaryButton,
      url: card?.primaryButton?.url
        ? sourcePromoCodeHandler(card?.primaryButton?.url)
        : card?.primaryButton?.url
    };

    return {
      ...card,
      primaryButton: updatedPrimaryButton
    };
  })
});

export const updatedSecondaryNavData = data => ({
  ...data,
  cta: {
    ...data?.cta,
    url: data?.cta?.url
      ? sourcePromoCodeHandler(data?.cta?.url)
      : data?.cta?.url
  }
});

export const updatedFeatureColsData = data => ({
  ...data,
  featureColCards: data?.featureColCards?.map(card => {
    const updatedButton = {
      ...card?.button,
      url: card?.button?.url
        ? sourcePromoCodeHandler(card?.button?.url)
        : card?.button?.url
    };

    return {
      ...card,
      button: updatedButton
    };
  })
});

export const updatedBrandedCardData = data =>
  data.cards.map(card => {
    const updatedCard = { ...card };
    if (card?.secondaryButton) {
      updatedCard.secondaryButton = card.secondaryButton
        ? sourcePromoCodeHandler(card.secondaryButton)
        : card.secondaryButton;
    }

    if (card?.primaryButton) {
      updatedCard.primaryButton = card.primaryButton
        ? sourcePromoCodeHandler(card.primaryButton)
        : card.primaryButton;
    }

    return updatedCard;
  });
